import { render, staticRenderFns } from "./im-custom-text.vue?vue&type=template&id=6cb4dff6&scoped=true"
import script from "./im-custom-text.vue?vue&type=script&lang=js"
export * from "./im-custom-text.vue?vue&type=script&lang=js"
import style0 from "./im-custom-text.vue?vue&type=style&index=0&id=6cb4dff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb4dff6",
  null
  
)

export default component.exports